// extracted by mini-css-extract-plugin
export var copyableItem = "_4f-0";
export var underlined = "_4f-1";